// extracted by mini-css-extract-plugin
export default {"wrap":"FormItem_wrap__FNUS4","fullWidth":"FormItem_fullWidth__rY-U-"};